import { createApp } from 'vue'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'
import BackButton from '@/src/vueComponent/BackButton.vue'

$(document).on('turbo:load turbo:render', () => {
  const materialReportShow = document.querySelector('#material-report-show')
  if (materialReportShow && !materialReportShow.__vue_app__) {
    createApp({ components: { BaseAlert, BackButton } }).mount(materialReportShow)
  }
})
